/*
 * XYNE Redesign — Collection grid logic
 * Sort dropdown, filter form auto-submit, mobile filter drawer.
 *
 * Approach: rely on Shopify's URL-param-driven filtering. When a customer
 * picks a sort or toggles a filter, we update the URL and reload — no AJAX
 * complexity, no client-side rendering. Works without JS as a baseline (the
 * filter form has a submit button), enhanced to be instant when JS is present.
 */
(function () {
  'use strict';

  function init() {
    var section = document.querySelector('[data-rd-coll]');
    if (!section) return;

    // ---------- Sort dropdown ----------
    var sortForm = section.querySelector('[data-rd-sort]');
    if (sortForm) {
      var sortSelect = sortForm.querySelector('select[name="sort_by"]');
      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', sortSelect.value);
          // Reset to page 1 when sort changes
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      }
    }

    // ---------- Filter drawer (mobile) ----------
    var filterTrigger = section.querySelector('[data-rd-filter-open]');
    var filterClose   = section.querySelector('[data-rd-filter-close]');
    var filterBackdrop = section.querySelector('[data-rd-filter-backdrop]');

    function openFilters() {
      document.body.classList.add('rd-coll-filters-open');
      if (filterBackdrop) filterBackdrop.hidden = false;
      // Trap focus into the filters container
      var filters = section.querySelector('[data-rd-filters]');
      if (filters) {
        setTimeout(function () {
          var firstFocusable = filters.querySelector('button, input, select, a');
          if (firstFocusable) firstFocusable.focus();
        }, 100);
      }
    }
    function closeFilters() {
      document.body.classList.remove('rd-coll-filters-open');
      if (filterBackdrop) {
        // Wait for transition to finish before fully hiding
        setTimeout(function () {
          if (!document.body.classList.contains('rd-coll-filters-open')) {
            filterBackdrop.hidden = true;
          }
        }, 240);
      }
      if (filterTrigger) filterTrigger.focus();
    }

    if (filterTrigger) filterTrigger.addEventListener('click', openFilters);
    if (filterClose)   filterClose.addEventListener('click', closeFilters);
    if (filterBackdrop) filterBackdrop.addEventListener('click', closeFilters);

    // Esc closes the drawer
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('rd-coll-filters-open')) {
        closeFilters();
      }
    });

    // ---------- Filter form auto-submit ----------
    // On desktop, the form has an Apply button — but we also auto-submit on
    // checkbox change for instant filter feedback. Mobile keeps the Apply
    // button visible for users who want to batch their filter selection.
    var filterForm = section.querySelector('[data-rd-filter-form]');
    if (filterForm) {
      // Build a debounced submit so rapid clicks don't fire multiple times
      var submitTimer = null;
      function debouncedSubmit() {
        if (submitTimer) clearTimeout(submitTimer);
        submitTimer = setTimeout(function () {
          // Preserve current sort_by when filtering
          var currentSort = new URLSearchParams(window.location.search).get('sort_by');
          if (currentSort) {
            var hidden = filterForm.querySelector('input[name="sort_by"]');
            if (!hidden) {
              hidden = document.createElement('input');
              hidden.type = 'hidden';
              hidden.name = 'sort_by';
              filterForm.appendChild(hidden);
            }
            hidden.value = currentSort;
          }
          filterForm.submit();
        }, 350);
      }

      // Auto-submit on checkbox change (desktop)
      // On mobile, we DON'T auto-submit because users might want to batch
      // their selections — the Apply button handles it. Use a media query.
      var isDesktop = window.matchMedia('(min-width: 900px)').matches;
      if (isDesktop) {
        filterForm.addEventListener('change', function (e) {
          if (e.target.type === 'checkbox' || e.target.type === 'number') {
            debouncedSubmit();
          }
        });
      }

      // Form submission preserves the URL's existing query params we don't manage
      filterForm.addEventListener('submit', function () {
        // Default form submission turns checked checkboxes into ?param=value
        // pairs. That's exactly what Shopify's filter URL contract expects.
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
